// extracted by mini-css-extract-plugin
export default {"container":"PointsHandler_container__ni-ke","radioContainer":"PointsHandler_radioContainer__yHyqS"};